// @flow

import React from "react";
import ReactDOM from "react-dom";

export default class Render {
    static bindings: { [_: string]: any } = {};

    static bindingName(type: string, name: string) {
        return type + "." + name;
    }

    static bind(type: string, name: string, component: any) {
        this.bindings[this.bindingName(type, name)] = component;
    }

    static bindComponent(name: string, component: any) {
        return this.bind("component", name, component);
    }

    static bindView(name: string, view: any) {
        return this.bind("view", name, view);
    }

    static getElementsByType(type: string) {
        return document.querySelectorAll(`[data-react-${type}]`);
    }

    static render(
        type: string,
        name: string,
        element: HTMLElement,
        props: any = null
    ) {
        const component = this.bindings[this.bindingName(type, name)];
        if (!component) throw new Error(`Unable to find ${type} ${name}`);

        ReactDOM.render(
            React.createElement(component, props || {}, null),
            element
        );
    }

    static renderByType(type: string) {
        const elements = this.getElementsByType(type);
        for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            const name: string =
                element.getAttribute("data-react-" + type) || "";

            const props = element.getAttribute("data-props");
            const parsedProps = props ? JSON.parse(props) : {};

            this.render(type, name, element, parsedProps);
        }
    }

    static renderAll() {
        this.renderByType("view");
        this.renderByType("component");
    }
}



// WEBPACK FOOTER //
// ./src/app/Render.js